<template>
    <div class="extract-line">
        <div class="extract-line__icon" v-if="showIcon">
            <i v-if="!getSvgPath" :class="getIcon" :style="getStyle"></i>
            <img v-if="getSvgPath" :src="getSvgPath" :style="getStyle" />
            <div class="extract-line__icon-vertical-line"></div>
        </div>
        <div class="extract-line__column">
            <div class="extract-line__row" :style="showPriceAndPayment() ? 'margin-top: 0px' : ''">
                <div class="extract-line__row-bold">{{ extract.title }}</div>
                <div>{{ getDate }}</div>
            </div>
            <div class="extract-line__row" style="margin-bottom: 10px">
                <span v-if="!showPriceAndPayment()" :style="getPaymentStyle"
                    >({{ getPlusOrMinusIfDeposit }}) {{ getFormattedAmount }} {{ getPaymentMethod }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import { dateToDayMonth } from '@/utils/filters';
import { convertNumberToBRL } from '@/utils';
import { iconsDictionary } from './iconsDictionary';
import { paymentType } from './paymentTypeDicitionary';
import moment from 'moment';

export default {
    name: 'ExtractLineDetails',

    props: {
        extract: {
            type: Object,
            required: true
        },
        showIcon: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        getFormattedAmount() {
            return convertNumberToBRL(parseFloat(this.extract.transactionValue));
        },
        isDeposit() {
            return this.extract.typeMovement === 'deposit';
        },
        getPlusOrMinusIfDeposit() {
            return this.isDeposit ? '+' : '-';
        },
        getDate() {
            const date = new Date(this.extract.createdAt);
            const today = moment();
            const yesterday = moment().subtract(1, 'days');

            if (moment(date).isSame(today, 'day')) return 'Hoje';
            if (moment(date).isSame(yesterday, 'day')) return 'Ontem';

            return dateToDayMonth(date);
        },
        getIcon() {
            return iconsDictionary[this.extract.transactionType]?.icon || '';
        },
        getSvgPath() {
            return iconsDictionary[this.extract.transactionType]?.svgPath || '';
        },
        getStyle() {
            return iconsDictionary[this.extract.transactionType]?.style;
        },
        getPaymentMethod() {
            return paymentType[this.extract.paymentType]?.name;
        },
        getPaymentStyle() {
            return this.isDeposit ? 'color: green' : 'color: red';
        }
    },

    methods: {
        showPriceAndPayment() {
            const paymentType = ['welcome', 'acquisition_subscription', 'renovation'];
            const checkType = paymentType.includes(this.extract.transactionType);
            return checkType;
        }
    }
};
</script>

<style lang="scss" scoped>
.extract-line {
    width: 100%;
    display: flex;
    &__icon {
        margin: 12px 12px 16px 0;

        display: flex;
        flex-direction: column;
        color: #a5a5a5;
        padding: 4px;

        &-vertical-line {
            width: 2px;
            height: 25px;
            border: 1px solid #d8d8d8;
            background: #d8d8d8;
            margin: 6px 0px -26px 11px;
        }

        svg,
        img {
            border-radius: 50%;
            border: solid 1px #a5a5a5;
            width: 24px;
            height: 24px;
            padding: 4px;
            transform: scale(1.1);
        }
    }

    &__column {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    &__row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 11px;
        &-bold {
            font-weight: bold;
        }
    }
}
</style>
